export enum NotGroupedComponent {
	ID = '00000000',
	DISPLAY_NAME = 'Not Grouped'
}
